module.exports = __webpack_public_path__ + "img/employment.09fc82b7.svg";